import {Injectable} from "@angular/core";
import {ICreateStripeAccountForCharity} from "../interfaces/charity/ICreateStripeAccountForCharity";
import {map, Observable} from "rxjs";
import {ICreateStripeAccountForCharityResult} from "../interfaces/charity/ICreateStripeAccountForCharityResult";
import {APIService} from "./api.service";
import {IStripeAccountQueryResult} from "../interfaces/stripe/IStripeAccountQueryResult";
import {ICreateStripeAccountLink} from "../interfaces/charity/ICreateStripeAccountLink";
import {ICreateStripeAccountLinkResult} from "../interfaces/charity/ICreateStripeAccountLinkResult";

@Injectable({
  providedIn: 'root'
})
export class StripeService
{
  constructor(private apiService: APIService) {}

  public fetchStripeAccountForCharity(charityIdP: string): Observable<IStripeAccountQueryResult> {
    return this.apiService.MakeGetRequest<IStripeAccountQueryResult>(`stripe/for-charity/${charityIdP}`).pipe(map((resultP) => {
      return resultP;
    }));
  }

  public createStripeAccountForCharity(createStripeAccountForCharityP: ICreateStripeAccountForCharity) : Observable<ICreateStripeAccountForCharityResult> {
    return this.apiService.MakePostRequest<ICreateStripeAccountForCharityResult>('stripe/create-stripe-account-for-charity', createStripeAccountForCharityP);
  }

  public generateStripeAccountLink(createStripeAccountLinkP: ICreateStripeAccountLink) : Observable<ICreateStripeAccountLinkResult> {
    return this.apiService.MakePostRequest<ICreateStripeAccountLinkResult>('stripe/create-stripe-account-link', createStripeAccountLinkP);
  }
}
